import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../api/index.js";

const initialState = {
  responseError: false,
  userClaims: null,
};

export const getUserClaims = createAsyncThunk(
  "auth/getUserClaims",
  async () => {
    try {
      const response = await api.getUserClaims();
      localStorage.setItem("url", response.data.APIURL);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch user claims:", error);
      throw error;
    }
  },
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthError: (state) => {
      state.responseError = true;
    },
    clearAuthError: (state) => {
      state.responseError = false;
    },
    setUserClaims: (state, action) => {
      state.userClaims = action.payload;
    },
    clearUserClaims: (state) => {
      state.userClaims = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserClaims.fulfilled, (state, action) => {
      state.userClaims = action.payload;
    });
  },
});

export const { setAuthError, clearAuthError, setUserClaims, clearUserClaims } = authSlice.actions;

export const authReducer = authSlice.reducer;
